import React from 'react';
import {BaseFieldProps} from '../../index';
import {Checkbox} from './checkbox';

export const BaseFieldCheckbox: React.FC<BaseFieldProps> = ({
  labelStyle,
  label,
  dotStyle,
  disabled,
  input,
  onCustomBlur,
  meta,
  style,
  testIDprefix,
}) => {
  return Checkbox({
    testIDprefix: testIDprefix ?? input.name ?? '',
    label,
    disabled,
    labelStyle,
    value: input.value,
    onChange: (value) => {
      if (input.onChange) {
        input.onChange(value);
      }

      if (onCustomBlur) {
        onCustomBlur(null, meta?.form, input.name, value);
      }
    },
    wrapExtraStyles: dotStyle,
    style: style as any,
  });
};
